<template>
  <div class="category-filter">

    <div
      class="filter-button"
      :class="{active: value === null}"
      @click="() => $emit('input', null)"
    >
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 2C0 0.90625 0.875 0 2 0H14C15.0938 0 16 0.90625 16 2V12C16 13.125 15.0938 14 14 14H2C0.875 14 0 13.125 0 12V2ZM6 4.25H14.5V2C14.5 1.75 14.25 1.5 14 1.5H6V4.25ZM4.5 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V4.25H4.5V1.5ZM1.5 5.75V8.25H4.5V5.75H1.5ZM1.5 9.75V12C1.5 12.2812 1.71875 12.5 2 12.5H4.5V9.75H1.5ZM6 12.5H14C14.25 12.5 14.5 12.2812 14.5 12V9.75H6V12.5ZM14.5 8.25V5.75H6V8.25H14.5Z"
          fill="currentColor"/>
      </svg>
      <span class="filter-label overline">{{$t('blog.all_categories')}}</span>
    </div>


    <div v-for="category in categories"
         :key="category.id"
         class="filter-button category-button"
         :class="{active: value === category.id}"
         @click="() => $emit('input', category)"
    >
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 2C0 0.90625 0.875 0 2 0H14C15.0938 0 16 0.90625 16 2V12C16 13.125 15.0938 14 14 14H2C0.875 14 0 13.125 0 12V2ZM6 4.25H14.5V2C14.5 1.75 14.25 1.5 14 1.5H6V4.25ZM4.5 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V4.25H4.5V1.5ZM1.5 5.75V8.25H4.5V5.75H1.5ZM1.5 9.75V12C1.5 12.2812 1.71875 12.5 2 12.5H4.5V9.75H1.5ZM6 12.5H14C14.25 12.5 14.5 12.2812 14.5 12V9.75H6V12.5ZM14.5 8.25V5.75H6V8.25H14.5Z"
          fill="#currentColor"/>
      </svg>
      <span class="filter-label overline">{{ category.details.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryFilter",
  props: {
    value: {
      type: String | null,
      required: false
    },
    categories: {
      type: Array,
      required: true
    }
  },

}
</script>

<style lang="scss">
@import "CategoryFilter";
</style>
